import { Image } from 'antd';
import ActionHeader from '../../../components/actionHeader';
import Page from '../../../components/page';

const PeopleInsight = () => {
  return (
    <Page header={<ActionHeader title="People Reserve (Coming soon)" />}>
      <div style={{ padding: 24 }}>
        <Image
          src="/people_insight.png"
          preview={false}
          style={{ width: '100%' }}
        ></Image>
      </div>
    </Page>
  );
};

export default PeopleInsight;
